import { createAction, createSlice } from '@reduxjs/toolkit';
import {
    LOGOUT,
    SELECT_CUSTOMER,
} from '../../constants/actions/auth.constants';
import ProfileActionConstants from '../../constants/actions/ProfileActionConstants';
import { AuthService } from '../../services/AuthService';

const getProfileSuccess = createAction<object>(
    ProfileActionConstants.GET_PROFILE_SUCCESS,
);
const selectCustomer = createAction<{ accessToken: string }>(SELECT_CUSTOMER);

const NAME = 'profile';

type ProfileState = object | null;

const initialState = null as ProfileState;

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProfileSuccess, (_, action) => action.payload)
            .addCase(selectCustomer, (state, action) => {
                const { accessToken } = action.payload;
                const data = AuthService.decodeUserData(accessToken);
                if (!data) {
                    return state;
                }
                const { email, firstName, lastName } = data;
                return state
                    ? ({ ...state, email, firstName, lastName } as ProfileState)
                    : ({ email, firstName, lastName } as ProfileState);
            })
            .addCase(LOGOUT, () => null);
    },
});

const ProfileSlice = {
    reducer: slice.reducer,
    actions: {
        getProfileSuccess,
        getProfileFail: (error: string) => ({
            type: ProfileActionConstants.GET_PROFILE_FAIL,
            error,
        }),
    },
};

export default ProfileSlice;
